import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import StepMenuItem, { TStepMenuItemProps } from '@r1-frontend/ui-react/components/StepMenu/StepMenuItem/StepMenuItem';
import Svg from '@r1-frontend/ui-react/components/svg/Svg';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const StyledStepMenuItem = styled(StepMenuItem)<TStepMenuItemProps>`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  
  padding: 8px;
  min-width: 32px;
  
  cursor: pointer;
  transition: transform .2s;

  background-color: ${COLORS.ButtonSecondary};
  
  &:active {
    transform: scale(0.89);
  }

  & > ${Svg}, & > img {
    height: 20px;
    width: 20px;
  }

  @media (max-width: ${wideBreakpoints.mobile}) {
    & > ${Svg}, & > img {
      height: 16px;
      width: 16px;
    }
  }
`;

export const Label = styled.p`
  ${FONTS.MediumXS};
  color: ${COLORS.TextPrimary};
  margin: 0;
`;
